var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 q-mt-md",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            key: "tab",
            attrs: { slot: "title", name: "area", label: _vm.$t("areas") },
            slot: "title"
          }),
          _c("q-tab-pane", { key: "area", attrs: { name: "area" } }, [
            _c("div", { staticClass: "row gutter-md" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "q-card",
                    { staticClass: "full-height" },
                    [
                      _c("q-card-title", [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("configure_country_area")) +
                            "\n\t\t\t\t\t\t"
                        )
                      ]),
                      _c("q-card-separator"),
                      _c(
                        "q-card-main",
                        [
                          _c(
                            "draggable",
                            { attrs: { list: _vm.areas } },
                            _vm._l(_vm.areas, function(a, index) {
                              return _c(
                                "q-card",
                                {
                                  key: a.area_id,
                                  staticClass: "cursor-pointer q-mb-md"
                                },
                                [
                                  _c("q-card-main", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-1 self-center" },
                                      [
                                        _c("q-icon", {
                                          attrs: {
                                            name: "fas fa-sort",
                                            color: "primary",
                                            size: "1.75rem"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-10 self-end" },
                                      [
                                        _c("p", { staticClass: "text-bold" }, [
                                          _vm._v(_vm._s(a.name))
                                        ])
                                      ]
                                    ),
                                    _c("div", { staticClass: "col-1" }, [
                                      _c(
                                        "span",
                                        [
                                          _c(
                                            "q-btn",
                                            {
                                              attrs: {
                                                flat: "",
                                                round: "",
                                                size: "1rem",
                                                color: "primary",
                                                icon: "fas fa-pencil-alt"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.changeAreaName(a)
                                                }
                                              }
                                            },
                                            [
                                              _c("q-tooltip", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(_vm.$t("rename")) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3 order-last" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_overview" })
                }
              }
            })
          ],
          1
        )
      ]),
      _vm.rename_area
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": { minWidth: "60vw", minHeight: "30vh" },
                "no-backdrop-dismiss": "",
                "no-esc-dismiss": ""
              },
              model: {
                value: _vm.rename_area,
                callback: function($$v) {
                  _vm.rename_area = $$v
                },
                expression: "rename_area"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            return _vm.clearNewName()
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$t("rename_area")) +
                            "\n\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "layout-padding" },
                    [
                      _c("p", [_vm._v(_vm._s(_vm.$t("rename")))]),
                      _c("q-input", {
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.saveNewName()
                          }
                        },
                        model: {
                          value: _vm.selected_area.name,
                          callback: function($$v) {
                            _vm.$set(_vm.selected_area, "name", $$v)
                          },
                          expression: "selected_area.name"
                        }
                      }),
                      _c("div", { staticClass: "row justify-end q-mt-lg" }, [
                        _c(
                          "div",
                          { staticClass: "row q-mr-sm" },
                          [
                            _c("q-btn", {
                              attrs: {
                                color: "tertiary",
                                label: _vm.$t("cancel"),
                                icon: "fas fa-times"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.clearNewName()
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("q-btn", {
                              attrs: {
                                color: "positive",
                                label: _vm.$t("save"),
                                icon: "far fa-save",
                                disable: _vm.selected_area.name.length === 0
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveNewName()
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }